import { SVGInterface } from "../../interface";

const Remove = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M18.7998 12.8H4.7998V10.8H18.7998V12.8Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Remove;
